<b>Issues From Drivers</b>
<hr>
<ul class="issueList">
  @for (issue of issues; track issue) {
    <li class="issue {{ issue.severity }}">
      <i class="fas {{ issue.icon }}"></i>
      <div>
        <strong>{{ issue.registration }}</strong>
        <span>{{ issue.description }}</span>
      </div>
    </li>
  }
</ul>
